export class SchoolYear {
    Id: number;
    Description: string;
    StartDate: string;
    FinishDate: string;
    SchoolYearState: SchoolYearState;
    isActive: boolean;

    constructor() {
        this.Id = -1;
        this.Description = '';
        this.StartDate = '';
        this.FinishDate = '';
        this.SchoolYearState = new SchoolYearState();
        this.isActive = true;
    }
}

export class SchoolYearState {
    Id: number;
    Name: string;

    constructor() {
        this.Id = -1;
        this.Name = '';
    }
}



// WEBPACK FOOTER //
// ./src/app/main/models/school-years/school-year.ts